import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeCheckIns: null,
  loading: false,
  error: null,
};

const checkInSlice = createSlice({
  name: "checkIn",
  initialState,
  reducers: {
    checkInSuccess: (state, action) => {
      state.activeCheckIns = action.payload;
      state.loading = false;
      state.error = null;
    },

    checkOutSuccess: (state, action) => {
      state.activeCheckIns = null;
      state.loading = false;
      state.error = null;
    },

    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },

    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  checkInSuccess,
  checkOutSuccess,
  setLoading,
  setError,
  clearError,
} = checkInSlice.actions;

export const selectActiveCheckIns = (state) => state.checkIn.activeCheckIns;
export const selectCheckInLoading = (state) => state.checkIn.loading;
export const selectCheckInError = (state) => state.checkIn.error;

export default checkInSlice.reducer;
